import { DecimalPipe, Time } from "@angular/common";


export interface IProjectElementsInput {
  projectId: number | undefined,
  groupId: number | undefined,
  moduleId: number | undefined,
  IsQueryForStaticElement: boolean
}

export interface IProjectElementsOutput {
  isMandatory: boolean,
  sortBy: number,
  defaultValue?: number | undefined,
  dependentElementDescription: string,
  dependentElementId?: number | undefined,
  elementDescription: string,
  elementHierarchy: number
  elementId: number
  groupId: number
  hasDependency: boolean,
  isActive: boolean,
  isDefaultSelect: boolean
  isNumbering: boolean
  isSerialNumber: boolean
  isVisible: boolean
  moduleDescription: string
  moduleId: number
  projectElementDescription: string
  projectId: number

}

export interface IProjectElementDetailsInput {
  projectId: number | undefined,
  groupId: number | undefined,
  deId?: number | undefined,
  moduleId: number | undefined,
  deDescription?: string | (string | number)[],
  dependentDEId?: number | undefined,
  dependentDEDId?: number | undefined,
  memberId?: number | undefined,
}


export interface IProjectElementDetailsOutput {
  deId: number,
  deDescription: string
  dedId: number,
  dedDescription: string,
  dedShortDescription: string,
  sortBy: number,
  displayText?: string
}

export interface PeerElementDetailsOutput {
  dE_Id: number,
  deD_Id: number,
  deD_Description: string,
  deD_Short_Description: string,
  deD_Name: string,
  sort_By: number
}

export interface PeerAllElementDetailsOutput {

  proscpserstg: PrjScpSerStgOutput[],
  memberEcdMD: MemberECDMDOutput[],
}

export interface PrjScpSerStgOutput {

  data_FOR: string,
  dE_Id: number,
  deD_Id: number,
  deD_Description: string,
  deD_Short_Description: string,
  sort_By: number,
  deD_Name: string
}

export interface MemberECDMDOutput {
  short_desc: string,
  stringAggList: string,
  sort_order: number
}


export interface ProjectTypeOutput {

  data_FOR: string,
  dE_Id: number,
  dED_Id: number,
  dED_Description: string,
  dED_Short_Description: string,
  sort_By: number,
  dED_Name: string
}

export interface ScopeReviewOutput {
  data_FOR: string,
  dED_Id: number,
  dED_Description: string,
  dED_Short_Description: string,
  sort_By: number,
  dED_Name: string
}

export interface ServiceIncludedOutput {
  data_FOR: string,
  dED_Id: number,
  dED_Description: string,
  dED_Short_Description: string,
  sort_By: number,
  dED_Name: string
}

export interface StagesReviewOutput {

  dATA_FOR: string,
  project_Id: number,
  group_Id: number,
  status_Id: number,
  status_Type: number,
  status_Order: number,
  active_Tag: string,
  group_Name: string,
  cED_Description: string,
  active_Tag_Desc: string,
  dED_Description: string,
  project_Status_Desc: string,
  scurve_Status_Desc: string,
  status_Desc: string
}

export interface MemberECDOutput {
  member_Name: string,
  dED_Short_Desc: string
}

export interface MemberDECDOutput {
  disc_Code: number,
  disc_Discription: string,
  userId: number,
  emp_name: string,
  emp_DiscName: string,
  disc_Manhour: number
}

export interface ProjectAllDetailsOutput {
  project_id: number,
  project_code: string,
  project_description: string,
  project_short_description: string,
  building_type: string,
  client: string,
  start_Date: Date,
  end_Date: Date,
  project_value_in_lakhs: DecimalPipe,
  design_fee_in_lakhs: DecimalPipe,
  project_brief_description: string,
  dpJ_NOP_DE_ID: number,
  dpJ_NOP_DED_ID: number,
  dpJ_Contract_Type_DE_ID: number,
  dpJ_Contract_Type_DED_ID: number,
  scope_of_work: string,
  built_up_area: number,
  site_area: number,
  proof_consultant_name: string,
  architectural_consultant_name: string,
  structural_consultant_name: string,
  date_of_LOI: Date,
  submission_date_of_project: Date,
  //submission_time_of_project : Time,
  is_edms_available: string,
  scope_of_peer_review: string
  division_name: string,
  seg_head: string 
}

export interface IProjectFeatureInput {
  projectId: number,
  groupId: number,
  featureDescription: string
}

export interface PeerElementInput {
  intProjectID?: number,
  intGroupID?: number,
  intDEID: number,
  intModuleID?: number,
  intUID: number
}

export interface PeerAllElementInput {
  intProjectID: number,
  intGroupID: number,
  intUID: number
}

export interface PeerProjectInput {
  intProjectID: number,
  intUID: number
}

export interface IProjectFeatureOutput {
  memberId: number,
  memberName: string
}

export interface IProjectMemberByRoleInput {
  projectId: number,
  groupId: number,
  roleId: number
}

export interface IProjectMemberByRolesInput {
  projectId: number,
  groupId: number,
  roleIds: string
}

export interface IProjectMemberByRolesOuput{
  roleId:number,
  memberId:number,
  memberName:string
}

export interface IDCIRevisionMaster {
  projectId: number,
  groupId: number,
  stageId: number,
  revisionNo: string,
  isActive: boolean
}

